import { Box } from '@mui/material';

import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { CompetencyTable } from './Competency';
import { DevelopmentActivities } from './DevelopmentActivities';
import { EducationTable } from './Education';
import { useDevelopmentTab } from './useDevelopmentTab';
import { useSxStyles } from './useStyles';

export const DevelopmentTab = () => {
  const sxStyles = useSxStyles();
  const {
    competenciesData,
    educationData,
    plansData,
    competencyEnum,
    compPosRelEnum,
    compProfEnum,
    isLoading,
  } = useDevelopmentTab();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <EducationTable educationData={educationData} />
      <Box component="hr" sx={sxStyles.hr} />
      <CompetencyTable
        competenciesData={competenciesData}
        competencyEnum={competencyEnum}
        compPosRelEnum={compPosRelEnum}
        compProfEnum={compProfEnum}
      />
      <Box component="hr" sx={sxStyles.hr} />
      <DevelopmentActivities plansData={plansData} />
    </>
  );
};
